import { FC } from 'react';

import { Box } from '@mui/material';
import { VerifiedBadge } from 'portfolio3/ui-kit/badges';

import * as styles from './styles';

interface IRewardCompactProps {
  image: string;
  isApproved: boolean;
}

const RewardCompact: FC<IRewardCompactProps> = ({ image, isApproved }) => {
  return (
    <Box className="reward-compact" sx={styles.root}>
      {isApproved && <VerifiedBadge />}
      <Box component="img" src={image} alt="Награда" sx={styles.image} />
    </Box>
  );
};

export default RewardCompact;
